import { render, staticRenderFns } from "./mold_count.vue?vue&type=template&id=4886f2c0&scoped=true&"
import script from "./mold_count.vue?vue&type=script&lang=js&"
export * from "./mold_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4886f2c0",
  null
  
)

export default component.exports